import React from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import LoginIcon from '@mui/icons-material/Login';
import { useCustomer } from '../../contexts/CustomerContext';
import { useSignInDialog } from './SignInDialog';

// Render-prop guard: shows children if signed in, a sign-in prompt
// otherwise. Used to wrap the /account pages — these have no public view,
// but we don't want a hard redirect either (the user just needs to log in).
const RequireCustomer: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useCustomer();
  const { openSignIn } = useSignInDialog();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress size={28} />
      </Box>
    );
  }

  if (!user) {
    return (
      <Box sx={{ textAlign: 'center', py: 8, px: 2 }}>
        <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
          Sign in to continue
        </Typography>
        <Typography variant="body2" sx={{ color: 'text.secondary', mb: 3 }}>
          Your account page is private. Sign in to access it.
        </Typography>
        <Button
          variant="contained"
          startIcon={<LoginIcon />}
          onClick={openSignIn}
          sx={{ textTransform: 'none' }}
        >
          Sign in
        </Button>
      </Box>
    );
  }

  return <>{children}</>;
};

export default RequireCustomer;
